import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
// oxlint-disable-next-line no-restricted-imports
import { createEntryPoint } from '@atlassian/react-entrypoint';

type OperationsReportsShellEntryPointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const operationsReportsShellEntrypoint: EntryPoint<
	OperationsReportsShellEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<OperationsReportsShellEntryPointComponent>(
		/* webpackChunkName: "async-eoc-global-reports-new-entrypoint" */ './OperationsReportsShell.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
